function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import { Query } from "react-apollo";
// import limitless
import { AutoComplete, createSuggestions } from "@limitless/portal";
const ENUM_QUERY = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "enumName"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "enumName"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "__type"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "name"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "enumName"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "enumValues"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "name"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 152,
    "source": {
      "body": "\n    query enumName($enumName: String!) {\n        __type(name: $enumName) {\n            enumValues {\n                name\n            }\n        }\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
const EnumTypeAutoComplete = ({
  selected,
  onChange,
  enumName,
  labels,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Query, {
    query: ENUM_QUERY,
    variables: {
      enumName
    }
  }, ({
    loading,
    error,
    data
  }) => {
    let suggestions = [];
    if (data && data.__type && data.__type.enumValues) {
      suggestions = createSuggestions(data.__type.enumValues, {
        valueDataKey: "name",
        labelDataKey: "name"
      });
      if (labels) {
        suggestions = suggestions.map(item => {
          var _labels$item$value;
          return {
            ...item,
            label: (_labels$item$value = labels[item.value]) !== null && _labels$item$value !== void 0 ? _labels$item$value : item.value
          };
        });
      }
      if (!selected) {
        onChange(suggestions[0]);
      }
    }
    return /*#__PURE__*/React.createElement(AutoComplete, _extends({
      value: loading ? null : selected,
      suggestions: suggestions,
      onChange: onChange,
      loading: loading,
      error: error,
      helperText: error ? "An error has occurred" : ""
    }, rest));
  });
};
EnumTypeAutoComplete.propTypes = {
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.object,
  enumName: PropTypes.string,
  labels: PropTypes.object
};
export default EnumTypeAutoComplete;